import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./css/index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthContextProvider } from "./providers/AuthContextProvider.tsx";

// 1. Import TanStack Query Client and Devtools
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ThemeContextProvider from "./providers/ThemeContextProvider.tsx";

// 2. Create a client instance outside the render loop
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Prevents aggressive refetching on window switch
      retry: 1, // Number of retry attempts on request failure
    },
  },
});

const VITE_GOOGLE_CLIENT_ID = import.meta.env?.VITE_GOOGLE_CLIENT_ID || "";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      {/* 3. Wrap your context layers with the provider */}
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <GoogleOAuthProvider clientId={VITE_GOOGLE_CLIENT_ID}>
            <ThemeContextProvider>
              <App />
            </ThemeContextProvider>
          </GoogleOAuthProvider>
        </AuthContextProvider>
        {/* 4. Mount Devtools (safely hidden in production by default) */}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
